import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Navbar.module.css'; // Using CSS Modules for component-specific styles

function Navbar() {
  const calendlyLink = "https://calendly.com/talk2boardai"; // REPLACE with your actual Calendly link

  return (
    <nav className={styles.navbar}>
      <div className={styles.container}>
        <Link to="/" className={styles.logo}>
          Talk2Board AI
        </Link>
        <ul className={styles.navLinks}>
          <li><Link to="/">Home</Link></li> {/* Added Home link for template */}
          <li><Link to="/about">About</Link></li>
          <li><Link to="/services">Services</Link></li>
          <li><Link to="/contact">Contact</Link></li>
          <li>
            <a href={calendlyLink} target="_blank" rel="noopener noreferrer" className="btn-nav-consultation">
              Book Consultation
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;